import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Checkbox from '../../../Checkbox';

interface TicketAssignCheckboxProps {
  checked: boolean;
  disabled: boolean;
  isLoading: boolean;
  onReserveTicket: (shouldAssign: boolean) => void;
}

export const TicketAssignCheckbox = ({
  checked,
  disabled,
  isLoading,
  onReserveTicket,
}: LT.WithChildren<TicketAssignCheckboxProps>): JSX.Element => {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleReserveTicket = () => {
    onReserveTicket(!isChecked);
  };

  return (
    <StyledTicketAssignCheckboxWrapper $disabled={disabled}>
      <StyledCheckbox
        checked={isChecked}
        disabled={disabled}
        onChange={handleReserveTicket}
      >
        Закрепить за менеджером
      </StyledCheckbox>
      {isLoading && <StyledLoader />}
    </StyledTicketAssignCheckboxWrapper>
  );
};

const StyledTicketAssignCheckboxWrapper = styled.div<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  padding: 5px 0;
`;

const StyledCheckbox = styled(Checkbox)<{ disabled: boolean }>`
  font-size: 14px;
  ${({ disabled }) => disabled && 'color: #92949a;'};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  input {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }
`;

const StyledLoader = styled.div`
  margin-left: auto;

  &:after {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 2px solid;
    border-color: #007aff transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
